<template lang="pug">
  .result
    h3.result-title ส่วนที่ 1 : ประวัติส่วนตัว (Personal Data) 
    .row
      .col-md-9
        .result-item.has-bg.mr-2rem
          .form-group.row
            strong.col-sm-2 คำนำหน้าชื่อ
            .col-sm-10.pl-75.d-flex
              span {{ form.name_title }}

        .result-item.mr-2rem
          .form-group.row
            strong.col-sm-2 ชื่อ - นามสกุล
            .col-sm-10.pl-75
              span {{ form.firstname }}  {{ form.lastname }}
              
        .result-item.has-bg.mr-2rem
          .row
            strong.col-sm-2 Name - Surname
            .col-sm-10.pl-75
              span {{ form.firstname_en }}  {{ form.lastname_en }}

        .result-item
          .row
            .col-sm-4
              .row
                strong.col-sm-6 อายุ

                .col-sm-6
                  span {{ form.age }}

            .col-sm-4
              .row
                strong.col-sm-6.text-right น้ำหนัก(ก.ก)

                .col-sm-6
                  span {{ form.weight }}

            .col-sm-4
              .row
                strong.col-sm-6.text-right ส่วนสูง(ซม.)

                .col-sm-6
                  span {{ form.height }}

        .result-item.has-bg
          .row
            .col-sm-4
              .row
                strong.col-sm-6 เชื้อชาติ
                span.col-sm-6 {{ form.race }}

            .col-sm-4
              .row
                strong.col-sm-6.text-right สัญชาติ
                span.col-sm-6 {{ form.nationality }}

            .col-sm-4
              .row
                strong.col-sm-6.text-right ศาสนา
                span.col-sm-6 {{ form.religion }}

        .result-item
          .row
            .col-sm-5
              .row
                strong.col-sm-5 อีเมล์

                span.col-sm-7 {{ form.email }}

            .col-sm-7
              .row
                strong.col-sm-4 เบอร์โทรศัพท์ที่ติดต่อ 
                span.col-sm-8 {{ form.phone_number }}

        .result-item
          .row
            .col-sm-5
              .row
                strong.col-sm-5 เลขที่บัตรประชาชน 
                span.col-sm-7 {{ form.id_card_number }}

            .col-sm-7
              .row
                strong.col-sm-3.text-right สถานทางสมรส
                span.col-sm-9 {{ form.marital_status }}

      .col-md-3 
        .profile
          label.text-center(
            :style="`background-image:url(${form.profile_url})`"
            :class="{ 'is-valid' : form.profile_url }"
          )
            div
              icon-upload-profile.icon
              span.d-block อัปโหลดรูปถ่ายหน้าตรง
                small.d-block (ขนาดไฟล์ไม่เกิน 2 mb)
              input(
                ref="file2"
                type="file"
                accept="image/x-png,image/gif,image/jpeg"
                @change="onFileChange"
              )

    .result-item
      .row
        .col-sm-9
          .row
            strong.col-sm-2 สถานทางทหาร
            span.col-sm-10 {{ form.military_status }}

    .result-item
      .row
        .col-sm-9
          .row
            strong.col-sm-2 ที่อยู่
            span.col-sm-10 
              span {{ form.house_no }} {{ form.building }} ม. {{ form.village_no }} {{ form.lane }} {{ form.road }} <br> 
              span ต. {{ form.sub_district }} อ. {{ form.district }} จ. {{ form.province }} {{ form.postal_code }}
                      
</template>

<script>
import { mapState } from 'vuex'
import IconUploadProfile from '../../../icons/UploadProfile.vue'
export default {
  components: { IconUploadProfile },
  data: () => ({
    loading: false,
    profileURL: null,
    form: {},
    nameTitle: [
      { strong: 'นาย', value: 'นาย' },
      { strong: 'นางสาว', value: 'นางสาว' },
      { strong: 'นาง', value: 'นาง' },
      { strong: 'อื่นๆ โปรดระบุ', value: 'อื่นๆ โปรดระบุ' },
    ],
    maritalStatus: [
      { strong: 'โสด', value: 'โสด' },
      { strong: 'สมรส', value: 'สมรส' },
      { strong: 'หย่า', value: 'หย่า' },
      { strong: 'หม้าย', value: 'หม้าย' },
      { strong: 'แยกกันอยู่', value: 'แยกกันอยู่' },
    ],
    militaryStatus: [
      { strong: 'ยังไม่ได้เกณฑ์', value: 'ยังไม่ได้เกณฑ์' },
      { strong: 'ผ่านการเกณฑ์ทหารแล้ว', value: 'ผ่านการเกณฑ์ทหารแล้ว' },
      { strong: 'ศึกษาวิชาทหาร', value: 'ศึกษาวิชาทหาร' },
    ],
  }),

  computed: {
    ...mapState(['personalData'])
  },

  mounted() {
    this.form = this.personalData
  },

  methods: {
    onChange() {
      this.$store.commit('SET_PERSONAL_DATA', this.form)
    },

    onSelected(address) {
      this.form.sub_district = address.subdistrict
      this.form.district = address.district
      this.form.province = address.province
      this.form.postal_code = address.postalCode
      this.$store.commit('SET_PERSONAL_DATA', this.form)
    },

    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      // this.step = 2
      this.createImage(files[0])
    },

    createImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.form.profile_url = e.target.result
        this.$store.commit('SET_PERSONAL_DATA', this.form)
      }
      reader.readAsDataURL(file)
    },
  
    async singUp() {
      this.loading = true
      try {
        // const response = await this.$api.user.signUp.create(this.form)
      } catch (error) {
        const errors = error.response.data.errors
        this.$refs.signUpForm.setErrors(errors)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.profile {
  position: relative;
  height: 80%;
  background: #f1f2f2;
  border: solid 1px #d1d3d4;
  margin-right: 4rem;
  margin-left: 1rem;
  margin-top: 0;

  &::after {
    position: absolute;
    bottom: -1px;
    left: -1px;
    right: -1px;
    height: 5px;
    background: #5f80ba;
    content: '';
    z-index: 3;
  }

  .icon {
    width: 60px;
    height: 52px;
    margin-bottom: 10px;
  }

  div {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
  }

  label {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background-size: cover;
    margin: 0;
    font-size: 1.125rem !important;
    cursor: pointer;

    &.is-valid {
      div {
        color: #fff;
        opacity: 0;
      }

      &:hover {
        div {
          opacity: 1;
        }

        &::after {
          position: absolute;
          top: -1px;
          bottom: -1px;
          left: -1px;
          right: -1px;
          background-color: rgba(0, 0, 0, 0.5);
          content: '';
        }
      }
    }

    input {
      position: absolute;
      opacity: 0;
    }
  }
}
</style>